"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
exports.__esModule = true;
exports.CompareValueComponent = void 0;
var angular = require("angular");
var compare_value_chart_1 = require("./compare-value.chart");
var basic_chart_component_1 = require("../basic-component/basic-chart.component");
function isGroupByAndColorBy(reportOptions) {
    if (!reportOptions) {
        return false;
    }
    return reportOptions.colorKey && reportOptions.groupKey;
}
var CompareValueComponent = /** @class */ (function (_super) {
    __extends(CompareValueComponent, _super);
    function CompareValueComponent($scope, $timeout) {
        var _this = 
        // This constructor is necessary for inject scope and timeout.
        _super.call(this, $scope, $timeout, 'CompareValue') || this;
        var ctrl = _this;
        ctrl.orientation = 'vertical';
        ctrl.chartType = 'bar';
        // $scope.$on('command:COMPARE_VALUE', (event, args) => ctrl.initComponent(event, args));
        $scope.$on('command:COMPARE_VALUE', function (event, args) {
            ctrl.initComponent(event, args);
            ctrl.menu = ctrl.getMenu();
            ctrl.menu.forEach(function (menuItem) {
                if (menuItem['name'] == 'Display') {
                    menuItem['items'].push({
                        'name': 'Rotate Chart',
                        'callback': function () {
                            ctrl.rotateChart();
                        }
                    });
                }
            });
        });
        return _this;
    }
    CompareValueComponent.prototype.getChartOptions = function (graph, options) {
        this.graph = graph;
        this.options = options;
        options['chartType'] = this.chartType;
        if (graph.shouldTotal && this.tableData &&
            isGroupByAndColorBy(this.tableData.reportOptions)) {
            return (0, compare_value_chart_1.getStackBarChartOptions)(graph, options);
        }
        else {
            return (0, compare_value_chart_1.getChartOptions)(graph, options);
        }
    };
    CompareValueComponent.prototype.rotateChart = function () {
        this.orientation = this.orientation === 'horizontal' ? 'vertical' : 'horizontal';
        this.chartType = this.orientation === 'horizontal' ? 'column' : 'bar';
        var chartOptions = this.getChartOptions(this.graph, this.options);
        (0, basic_chart_component_1.makeChart)(chartOptions);
    };
    CompareValueComponent = __decorate([
        (0, basic_chart_component_1.Component)({
            bindings: {
                menu: '='
            },
            template: require("./compare-value.component.html")
        }),
        __metadata("design:paramtypes", [Object, Object])
    ], CompareValueComponent);
    return CompareValueComponent;
}(basic_chart_component_1.BasicChartComponent));
exports.CompareValueComponent = CompareValueComponent;
angular.module('smartorg.r6.acts.compareValue', []).component('compareValue', CompareValueComponent);
exports["default"] = 'smartorg.r6.acts.compareValue';
//# sourceMappingURL=compare-value.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/compare-value2/compare-value.component.js